// extracted by mini-css-extract-plugin
module.exports =  {"container":"kMSLXWd118gmyGs9ro5j","text":"_iVtngn3FqYAmWj0NT3t","link":"z558Zsj5ABZGLFx0e2CU","btn":"dE3NWKPD5whbgV38diF4"};